import React, { useState } from "react";
import Modal from "react-modal";
import ModalHeadAndClose from "../../../payouts-wtf/common/ModalHeadAndClose";
import ReactImageGallery from "../../../components-react/gallery/ReactImageGallery";

const DetailListings = ({ row }) => {
  const iniModValues = {
    isModOpen: false,
    rowData: "",
    cardName: "",
  };
  const [modValues, setModValues] = useState(iniModValues);

  const imgArrayLength = Number(row?.images_arr?.length || 0) > 0;
  const vdoArrayLength = Number(row?.video_arr?.length || 0) > 0;

  function onCloseModal() {
    setModValues(iniModValues);
  }

  return (
    <>
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Detail Modal"
        ariaHideApp={false}>
        <div className={`createNewCTOModalContainer mod-width-50p`}>
          <ModalHeadAndClose
            title={
              modValues.cardName === "staff_photo"
                ? modValues.rowData?.name
                : modValues.cardName?.replace(/_/g, " ")
            }
            onClose={onCloseModal}
          />

          {modValues.cardName === "images" ? (
            <div className="image-gallery-container mt30">
              <ReactImageGallery
                imagesArray={
                  modValues.rowData?.images_arr?.length > 0
                    ? modValues.rowData.images_arr
                    : []
                }
              />
            </div>
          ) : modValues.cardName === "videos" ? (
            <div className="image-gallery-container mt30">
              <ReactImageGallery
                imagesArray={
                  modValues.rowData?.video_arr?.length > 0
                    ? modValues.rowData.video_arr
                    : []
                }
              />
            </div>
          ) : null}
        </div>
      </Modal>

      <div className="user-profile-container staff-onboarding-detail-modal">
        <div className="user-profile-details">
          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">task description</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">{row?.description || "NA"}</p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">processed by</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">
                {row?.processed_by_name || "NA"}
                <br />
                <small className="lowercase">
                  {row?.processed_by_mobile || ""}
                  <br />
                  {row?.processed_by_email || ""}
                </small>
              </p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">pocesse description</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">{row?.processed_description || "NA"}</p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">images</p>
            </div>
            <div className="user-details-info">
              <p
                className={`info-name ${imgArrayLength ? "link" : ""}`}
                onClick={() =>
                  imgArrayLength &&
                  setModValues((prevs) => ({
                    ...prevs,
                    isModOpen: true,
                    cardName: "images",
                    rowData: row,
                  }))
                }>
                {imgArrayLength ? "View" : "NA"}
              </p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">videos</p>
            </div>
            <div className="user-details-info">
              <p
                className={`info-name ${vdoArrayLength ? "link" : ""}`}
                onClick={() =>
                  vdoArrayLength &&
                  setModValues((prevs) => ({
                    ...prevs,
                    isModOpen: true,
                    cardName: "videos",
                    rowData: row,
                  }))
                }>
                {vdoArrayLength ? "View" : "NA"}
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DetailListings;
